import { render, staticRenderFns } from "./SizeSkuItem.vue?vue&type=template&id=2d741734&scoped=true&"
import script from "./SizeSkuItem.vue?vue&type=script&lang=js&"
export * from "./SizeSkuItem.vue?vue&type=script&lang=js&"
import style0 from "./SizeSkuItem.vue?vue&type=style&index=0&id=2d741734&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d741734",
  null
  
)

export default component.exports